(function () {
  const form = document.querySelector('[data-klaviyo-form]');
  if (!form) return;

  const key = form.dataset.klaviyoKey;
  const listId = form.dataset.klaviyoList;
  const successMessage = form.dataset.success || 'You\u2019re subscribed!';

  const input = form.querySelector('input[type="email"]');
  const button = form.querySelector('button[type="submit"]');
  const inputRow = form.querySelector('.footer__newsletter-input-row');
  const statusEl = form.closest('.footer__newsletter-block')
    ? form.closest('.footer__newsletter-block').querySelector('.footer__newsletter-status')
    : null;

  if (!input || !button || !inputRow) return;

  let keyboardMode = false;

  form.addEventListener('keydown', function (event) {
    if (event.key === 'Tab') keyboardMode = true;
  });

  form.addEventListener('pointerdown', function () {
    keyboardMode = false;
  });

  input.addEventListener('focus', function () {
    inputRow.classList.toggle('footer__newsletter-input-row--keyboard-focus', keyboardMode);
  });

  input.addEventListener('blur', function () {
    inputRow.classList.remove('footer__newsletter-input-row--keyboard-focus');
  });

  function renderErrorState(message) {
    if (!statusEl) return;

    const errorIconMarkup =
      '<svg class="icon icon-error" viewBox="0 0 13 13">' +
      '<circle cx="6.5" cy="6.5" r="5.5" stroke="#fff" stroke-width="2"/>' +
      '<circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width=".7"/>' +
      '<path fill="#fff" d="m5.874 3.528.1 4.044h1.053l.1-4.044zm.627 6.133c.38 0 .68-.288.68-.656s-.3-.656-.68-.656-.681.288-.681.656.3.656.68.656"/>' +
      '</svg>';

    const iconWrapper = document.createElement('span');
    iconWrapper.className = 'footer__newsletter-check';
    iconWrapper.setAttribute('aria-hidden', 'true');
    iconWrapper.innerHTML = errorIconMarkup;

    const textWrapper = document.createElement('span');
    textWrapper.textContent = message;

    statusEl.classList.add('footer__newsletter-status--error');
    statusEl.innerHTML = '';
    statusEl.appendChild(iconWrapper);
    statusEl.appendChild(textWrapper);
  }

  function clearStatus() {
    if (!statusEl) return;
    statusEl.textContent = '';
    statusEl.classList.remove('footer__newsletter-status--error');
  }

  function renderSuccessState() {
    if (!statusEl) return;

    const successIconMarkup =
      '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<rect width="16" height="16" rx="8" fill="white"/>' +
      '<g clip-path="url(#clip0_footer_newsletter_success)">' +
      '<path d="M5 8L7 10L11 6" stroke="#FE2B30" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</g>' +
      '<defs>' +
      '<clipPath id="clip0_footer_newsletter_success">' +
      '<rect width="12" height="12" fill="white" transform="translate(2 2)"/>' +
      '</clipPath>' +
      '</defs>' +
      '</svg>';

    const iconWrapper = document.createElement('span');
    iconWrapper.className = 'footer__newsletter-check';
    iconWrapper.setAttribute('aria-hidden', 'true');
    iconWrapper.innerHTML = successIconMarkup;

    const textWrapper = document.createElement('span');
    textWrapper.textContent = successMessage;

    statusEl.classList.remove('footer__newsletter-status--error');
    statusEl.innerHTML = '';
    statusEl.appendChild(iconWrapper);
    statusEl.appendChild(textWrapper);

    form.hidden = true;
  }

  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  form.addEventListener('submit', async function (e) {
    e.preventDefault();
    clearStatus();

    if (!key || !listId) {
      renderErrorState('Newsletter is not configured yet. Please add your Klaviyo key and list ID.');
      return;
    }

    const email = input.value.trim();

    if (!email) {
      renderErrorState('Please enter your email address.');
      input.focus();
      return;
    }

    if (!isValidEmail(email)) {
      renderErrorState('Please enter a valid email address.');
      input.focus();
      return;
    }

    button.disabled = true;
    form.setAttribute('aria-busy', 'true');

    try {
      const response = await fetch(
        'https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(key),
        {
          method: 'POST',
          headers: {
            'content-type': 'application/json',
            revision: '2024-02-15',
          },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                profile: {
                  data: {
                    type: 'profile',
                    attributes: { email: email },
                  },
                },
              },
              relationships: {
                list: {
                  data: { type: 'list', id: listId },
                },
              },
            },
          }),
        }
      );

      if (response.ok || response.status === 202) {
        renderSuccessState();
      } else if (response.status === 409) {
        renderSuccessState();
      } else {
        // Unexpected error
        let message = 'Something went wrong. Please try again.';
        try {
          const data = await response.json();
          if (data.errors && data.errors[0] && data.errors[0].detail) {
            message = data.errors[0].detail;
          }
        } catch (_) {
          // ignore JSON parse errors
        }
        renderErrorState(message);
        button.disabled = false;
        form.removeAttribute('aria-busy');
      }
    } catch (_) {
      // Network error
      renderErrorState('Something went wrong. Please check your connection and try again.');
      button.disabled = false;
      form.removeAttribute('aria-busy');
    }
  });
})();
